import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=092122bd&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=092122bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092122bd",
  null
  
)

export default component.exports